import { useAuth } from "@/context/AuthContext";

export default function BrickGrid({ bricks, selectable = false, selected = [], onToggle }) {
  const { user } = useAuth();
  if (!bricks?.length) return null;
  // show max 400 cells to keep the grid performant
  const display = bricks.slice(0, 400);
  return (
    <div className="grid grid-cols-20 gap-1" style={{ gridTemplateColumns: "repeat(20, minmax(0, 1fr))" }}>
      {display.map((b) => {
        let cls = "brick-cell ";
        if (b.status === "sold") {
          cls += user && b.owner_id === user.id ? "brick-mine" : b.listed_for_resale ? "brick-resale" : "brick-sold";
        } else if (selected.includes(b.id)) {
          cls += "brick-selected";
        } else {
          cls += "brick-available";
        }
        return (
          <button
            key={b.id}
            type="button"
            data-testid={`brick-${b.brick_number}`}
            title={`${b.token_id} — ${b.status}${b.listed_for_resale ? " • for resale" : ""}`}
            className={cls}
            disabled={!selectable || b.status !== "available"}
            onClick={() => selectable && b.status === "available" && onToggle?.(b.id)}
          />
        );
      })}
      {bricks.length > display.length && (
        <div className="col-span-full text-center text-xs text-gray-500 mt-2">
          Showing 400 of {bricks.length} bricks
        </div>
      )}
    </div>
  );
}
